import { BooleanFieldVariant, OptionsFieldVariant } from "@entaconsulting/form";

export const CONFIRMATION_MESSAGE: string =
  "Are you sure you want to leave the page? Changes will be lost.";

export const CONFIRMATION_MESSAGE_DELETE_CONTAINER_ELEMENT: string =
  "Are you sure you want to delete these Container Element? Child elements will also be removed.";

export enum EditorModeTab {
  VisualEditor = 0,
  Preview,
  CodeEditor,
}

const COMMON_SUPPORTED_SCHEMA_FIELDS: string[] = [
  "type",
  "required",
  "validationExpressions",
];

export const SUPPORTED_SCHEMA_FIELDS_BY_TYPE: Record<string, string[]> = {
  text: [
    ...COMMON_SUPPORTED_SCHEMA_FIELDS,
    "length",
    "min",
    "max",
    "matches",
    "inputMask",
    "blacklist",
    "whitelist",
  ],
  options: [...COMMON_SUPPORTED_SCHEMA_FIELDS, "options"],
  // Deprecated
  select: [...COMMON_SUPPORTED_SCHEMA_FIELDS, "options"],
  number: [
    ...COMMON_SUPPORTED_SCHEMA_FIELDS,
    "min",
    "max",
    "blacklist",
    "whitelist",
    "inputMask",
  ],
  // Deprecated
  multilineText: [
    ...COMMON_SUPPORTED_SCHEMA_FIELDS,
    "length",
    "min",
    "max",
    "matches",
    "inputMask",
    "blacklist",
    "whitelist",
  ],
  email: [
    ...COMMON_SUPPORTED_SCHEMA_FIELDS,
    "min",
    "max",
    "blacklist",
    "whitelist",
  ],
  boolean: [...COMMON_SUPPORTED_SCHEMA_FIELDS],
  date: [...COMMON_SUPPORTED_SCHEMA_FIELDS],
  datetime: [...COMMON_SUPPORTED_SCHEMA_FIELDS],
  attachment: [
    ...COMMON_SUPPORTED_SCHEMA_FIELDS,
    "fileType",
    "multiple",
    "maxSizeMb",
  ],
  password: [
    ...COMMON_SUPPORTED_SCHEMA_FIELDS,
    "length",
    "min",
    "max",
    "matches",
    "inputMask",
    "blacklist",
    "whitelist",
  ],
  url: [
    ...COMMON_SUPPORTED_SCHEMA_FIELDS,
    "min",
    "max",
    "blacklist",
    "whitelist",
  ],
  list: ["type", "schema", "validationExpressions", "min", "max"],
  tristate: [...COMMON_SUPPORTED_SCHEMA_FIELDS],
};

export const OPTIONS_FIELD_VARIANT_DEFAULT = "options";
export const BOOLEAN_FIELD_VARIANT_DEFAULT = "switch";
export const OPTIONS_FIELD_VARIANT: OptionsFieldVariant[] = [
  "select",
  "options",
  "combobox",
];
export const BOOLEAN_FIELD_VARIANT: BooleanFieldVariant[] = [
  "checkbox",
  "switch",
];

type Command = {
  title: string;
  command: string;
};

export const KEYBOARD_SHORTCUTS: Record<string, Command[]> = {
  General: [
    { title: "Close", command: "Escape" },
    { title: "Show keyboard shortcuts", command: "Alt+." },
  ],
  Modes: [
    { title: "Insert Field", command: "Alt+1" },
    { title: "Insert Image", command: "Alt+2" },
    { title: "Insert Text", command: "Alt+3" },
    { title: "Insert Layout", command: "Alt+4" },
    { title: "Insert Table", command: "Alt+5" },
    { title: "Exit from Insertion Mode", command: "Escape" },
  ],
};

export enum PanelSections {
  NameAndType = "NameAndType",
  General = "General",
  Options = "Options",
  TableColumns = "TableColumns",
  Appearance = "Appearance",
  Behavior = "Behavior",
  Validation = "Validation",
  ValidationExpressions = "ValidationExpressions",
}

export const FIELDS_BY_SECTION: Record<string, string[]> = {
  Appearance: [
    "variant",
    "inputMask",
    "spacing",
    "align",
    "verticalAlign",
    "margin",
    "weight",
    "style",
    "textVariant",
    "placeholder",
    "prefix",
    "multiline",
    "height",
    "rowHeight",
  ],
  Behavior: [
    "readonly",
    "visibility",
    "computed",
    "showErrorMarkers",
    "canAdd",
    "canDelete",
    "canSort",
    "canShrink",
  ],
  Validation: [
    "whitelist",
    "blacklist",
    "length",
    "min",
    "max",
    "maxSizeMb",
    "fileType",
    "multiple",
    "matches",
  ],
};
